module.exports = __webpack_public_path__ + "static/media/Team 7 - Furiously United.cbdf7ff6.PNG";